export enum BreadCrumbLabel {
  STONE_SEARCH = "Stone Search",
  STONE_DETAILS = "Stone Details",
  SETTING_SEARCH = "Setting Search",
  SETTING_DETAILS = "Setting Details",
  REVIEW = "Review",
  REQUEST_DETAILS = "Request Details",
  MATCHING_STONE = "Matching Stone",
  ORDER_CART = "Order Cart",
}

export interface NavigationHistoryEntry {
  screen: string;
  params?: any;
}

export interface NavigationHistoryState {
  history: NavigationHistoryEntry[];
  currentIndex: number;
  showConfirmationDialog: boolean;
  targetNavigationIndex: number | null;
}
